import { render, staticRenderFns } from "./OpenBankingCelebrationPopup.vue?vue&type=template&id=c4e4f89c"
import script from "./OpenBankingCelebrationPopup.vue?vue&type=script&lang=js"
export * from "./OpenBankingCelebrationPopup.vue?vue&type=script&lang=js"
import style0 from "./OpenBankingCelebrationPopup.vue?vue&type=style&index=0&id=c4e4f89c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports